module.exports = __webpack_public_path__ + "img/色相_饱和度 6 灰大素材 1.ebd24c2b.png";